import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';
import { ModalServiceInterface } from 'pf-frontend-common/src/service/modal/service.interface';

import { PropertyModel } from 'common/data/property/model';
import { PropertyShareStatsGtmCtaClick } from 'common/module/form/property-share/stats/gtm/cta-click';
import { PropertyShareStatsGtmCtaFinish } from 'common/module/form/property-share/stats/gtm/cta-finish';
import { FormPropertyShareViewStore } from 'common/module/form/property-share/view-store';
import { FormPropertyShareViewStoreEvent } from 'common/module/form/property-share/view-store.event';
import { ViewDynamicInterface } from 'common/module/view/dynamic.interface';
import { StatsServiceInterface } from 'common/service/stats/service.interface';

export class FormPropertyShareView {
  /**
   * Constructor
   */
  constructor(
    private modalService: ModalServiceInterface,
    private viewDynamic: ViewDynamicInterface<FormPropertyShareViewStore>,
    private statsService: StatsServiceInterface
  ) {}

  /**
   * Initialize the view
   */
  public initialize(): void {
    this.destroy();

    this.viewDynamic.initialize({
      element: this.modalService.getContentElement(),
    });

    this.viewDynamic.getViewStore().initialize();

    this.viewDynamic.getViewStore().getEventEmitter().addListener(FormPropertyShareViewStoreEvent.close, this.onClose);

    this.viewDynamic
      .getViewStore()
      .getEventEmitter()
      .addListener(FormPropertyShareViewStoreEvent.submit, this.onSubmit);
  }

  /**
   * Remove event listeners
   */
  public destroy(): void {
    this.viewDynamic
      .getViewStore()
      .getEventEmitter()
      .removeListener(FormPropertyShareViewStoreEvent.close, this.onClose);
  }

  /**
   * Render the view
   */
  public render(): void {
    this.setOpen(true);
    this.logStat(PropertyShareStatsGtmCtaClick);
  }

  /**
   * Update the view store's model
   */
  public updateModel(model: PropertyModel): void {
    this.viewDynamic.getViewStore().updateModel(model);
  }

  /**
   * Log form stats
   */
  private logStat(stat: DataKeyValueStringInterface): void {
    this.statsService.ctaClick({
      cta: {
        customEvent: stat,
      },
    });
  }

  /**
   * Set the open state of the form
   */
  private setOpen(isOpen: boolean): void {
    if (isOpen) {
      this.viewDynamic.render();
      this.modalService.open();
    } else {
      this.modalService.close();

      // Empty the modal
      this.modalService.setContentView(null);
    }
  }

  /**
   * Closed form
   */
  private onClose = (): void => {
    this.setOpen(false);
  };

  /**
   * On form submitted successfully
   */
  private onSubmit = (): void => {
    this.logStat(PropertyShareStatsGtmCtaFinish);
  };
}
